import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/shared/shared.module';
import { EsteiraApuracaoRoutingModule } from './esteira-apuracao-routing.module';
import { EsteiraApuracaoComponent } from './esteira-apuracao.component';
import { EsteiraListComponent } from './esteira-list/esteira-list.component';
import { EsteiraContractCardComponent } from './esteira-contract-card/esteira-contract-card.component';
import { EsteiraContractFilterComponent } from './esteira-contract-filter/esteira-contract-filter.component';

@NgModule({
  declarations: [
    EsteiraApuracaoComponent,
    EsteiraListComponent,
    EsteiraContractCardComponent,
    EsteiraContractFilterComponent
  ],
  imports: [
    CommonModule,
    EsteiraApuracaoRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  exports: [EsteiraContractCardComponent]
})
export class EsteiraApuracaoModule {}
